// BB Global Fixes — sold-out badge suppression + hot-seller labeling
(function(){
  var SOLD_OUT_STRINGS = ['sold out', 'sold-out', 'unavailable'];
  function hideSoldOut(){
    document.querySelectorAll('.badge, .card__badge, .price__badge, .card-information__badge, [class*="badge"]').forEach(function(el){
      var txt = (el.textContent || '').trim().toLowerCase();
      if (SOLD_OUT_STRINGS.indexOf(txt) > -1) {
        el.style.display = 'none';
      }
    });
  }
  function tagHotSellers(){
    // If a product card has a data attribute or class indicating hot-seller tag, add a visible badge
    document.querySelectorAll('[data-product-tags*="hot-seller"], [class*="hot-seller"]').forEach(function(card){
      if (card.querySelector('.bb-hot-badge')) return;
      var badge = document.createElement('span');
      badge.className = 'bb-hot-badge';
      badge.textContent = 'Hot seller';
      badge.style.cssText = 'position:absolute;top:8px;left:8px;background:#A88B5F;color:#FAF7F2;padding:4px 10px;border-radius:4px;font-family:\'Inter\',sans-serif;font-size:11px;letter-spacing:0.08em;text-transform:uppercase;font-weight:500;z-index:5;';
      var container = card.querySelector('.card, .card__inner, .media, .card__media') || card;
      if (getComputedStyle(container).position === 'static') container.style.position = 'relative';
      container.appendChild(badge);
    });
  }
  function run(){ hideSoldOut(); tagHotSellers(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }
  setTimeout(run, 500);
  setTimeout(run, 1500);
})();
